const langDropDownTheme = {
    color: '#fff',

    '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
    },

    '&:hover .MuiOutlinedInput-notchedOutline': {
        border: 'none',
    },

    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: 'none',
    },

    '& .MuiSelect-icon': {
        color: '#fff',
    },
}

export default langDropDownTheme
